import { render, staticRenderFns } from "./TextInputWithRightHeader.vue?vue&type=template&id=64549cb6&scoped=true&"
import script from "./TextInputWithRightHeader.vue?vue&type=script&lang=js&"
export * from "./TextInputWithRightHeader.vue?vue&type=script&lang=js&"
import style0 from "./TextInputWithRightHeader.vue?vue&type=style&index=0&id=64549cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64549cb6",
  null
  
)

export default component.exports